import { AttachmentFile, AttachmentFileType, CloudFile } from 'owa-attachment-file-types';
import { AttachmentMenuAction, AttachmentState } from 'owa-attachment-full-data';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import { ClientItemId, MailboxInfo } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';

export default {
    AttachmentCreationClassicFromLocalFile: {
        name: 'AttachmentCreationClassicFromLocalFile',
        customData: (
            parentItemId: ClientItemId,
            attachment: AttachmentType,
            cancellationId: string,
            backingObject: Blob,
            attachmentState: AttachmentState
        ) => {
            return backingObject ? [backingObject.size] : [0]; // Log 0 if no backing object
        },
    },
    AttachmentCreationFromRecentAttachment: {
        name: 'AttachmentCreationFromRecentAttachment',
        customData: (
            parentItemId: ClientItemId,
            attachment: AttachmentType,
            cancellationId: string,
            backingObject: AttachmentFile,
            attachmentState: AttachmentState,
            isCloudFile: boolean
        ) => {
            return backingObject ? [backingObject.size] : [0]; // Log 0 if no backing object
        },
    },
    AttachmentCreationCloudyFromAttachmentDataProvider: {
        name: 'AttachmentCreationCloudyFromAttachmentDataProvider',
        customData: (
            parentItemId: ClientItemId,
            cancellationId: string,
            backingObject: CloudFile,
            attachmentState: AttachmentState
        ) => [backingObject.providerType],
    },
    AttachmentCreationCloudyFromLocalFile: {
        name: 'AttachmentCreationCloudyFromLocalFile',
    },
    AttachmentDeletionAction: {
        name: 'AttachmentDeletionAction',
        customData: (
            attachmentWellViewState: AttachmentWellViewState,
            attachmentState: AttachmentState,
            parentItemId: ItemId,
            attachmentFileType: AttachmentFileType
        ): any => {
            return {
                generatedAttachmentId: attachmentState.attachmentId.Id,
            };
        },
        cosmosOnlyData: (
            attachmentWellViewState: AttachmentWellViewState,
            attachmentState: AttachmentState,
            parentItemId: ItemId,
            attachmentFileType: AttachmentFileType
        ): string =>
            JSON.stringify({
                attachmentId: attachmentState.attachmentId.Id,
                fileType: attachmentFileType,
            }),
    },
    AttachmentWellInitialization: {
        name: 'AttachmentWellInitialization',
        customData: (
            attachments: AttachmentType[],
            mailboxInfo: MailboxInfo,
            attachmentWell: AttachmentWellViewState,
            forceUpdateAttachmentsInStore: boolean,
            isInitializationForCompose: boolean,
            unsupportedMenuActions?: AttachmentMenuAction[],
            parentItemId?: ItemId,
            infoBarAddHandler?: (
                messageId: string,
                infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
            ) => void,
            infoBarRemoveHandler?: (infoBarMessageIds: string[]) => void
        ) => ({
            hasAttachments: attachments && attachments.length > 0,
            isCompose: isInitializationForCompose,
        }),
        options: {
            sessionSampleRate: 1,
        },
    },
};
